export default __webpack_public_path__ + "static/media/ico-sort-dsc.c2f5cffe.svg";